import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[formLandingFooter]',
    standalone: false
})
export class FormLandingFooterDirective {

  constructor(public viewContainerRef: ViewContainerRef) { }

}
